import { service } from './service';
import { SORT_ORDER } from '@/resources/Constants'
import _ from 'lodash';

const state = {
  all: {},
  documents: [],
};

const getters = {
  documents: state => state.documents,
};

const actions = {
  async getDocuments({ commit }, id) {
    const results = await service.getDocuments(id);

    commit('setDocuments', results);
  },
};

const mutations = {
  setDocuments(state, payload) {
    state.documents = [];
    state.documents = payload;    
  },
};

const documents = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default documents;
